import React, { Component } from "react";
import axios from 'axios';
import Flatpickr from "react-flatpickr";
import {
  Container,
  Dropdown,
  Form,
  Input,
  TextArea,
  Grid,
  Button,
  Menu
} from "semantic-ui-react";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import DropzoneCommon from "../../components/content/DropzoneCommon";
import ResponseMessage from "../../components/common/ResponseMessage";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y-m-d H:i:S",
};
const resetState = () => {
  return {
    isMounted: false,
    isLoading: true,
    xhrStatus: '',
    xhrMessage: '',
    postsId: 0,
    customScheduleStatus: false,
    canned: [],
    tokenIds: [],
    eventList: [],
    errorUrlStatus: false,
    errorUrlMessage: '',
    startIndex: 0,
    profile: {
      id: 0,
      token_id: [],
      resource_id: 0,
      title: "",
      content: "",
      schedule: "none",
      post_at: "",
      event_id: 0,
      images: []
    }
  };
};
class SocialPostsForm extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();
    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.postsId = id;
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/social/posts");
      return;
    }
    document.getElementsByName("post_at")[0].style.display="none";
    this.setState({ isMounted: true });
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  fetchData = () => {
    let self = this;
    let promises = [
      request.get(this, "api:/social/accounts", {}),
      request.get(this, "api:/social/canned", {}),
      request.get(this, "api:/event", {
        sort: [{ "id": "start_at", "desc": true }],
      })
    ];
    if (this.state.postsId > 0) {
      promises.push(
        request.get(this, `api:/social/post/${this.state.postsId}`, {}),
      );
    }
    Promise.all(promises).then(function (values) {
      self.setTokenIds(values[0]);
      self.setCannedMessages(values[1]);
      self.setEventList(values[2]);
      if (values[3]) {
        self.setProfile(values[3]);
      }
      self.setState({ isLoading: false });
    });
  };
  handleChange = (e, { name, value }) => {
    let data = { ...this.state.profile };
    data[name] = value;
    if (value === "custom") {
      this.setState({ customScheduleStatus: true });
      document.getElementsByName("post_at")[0].style.display="block";
    }
    if (value === "event" || value === "winner" || value === "none") {
      this.setState({ customScheduleStatus: false });
      document.getElementsByName("post_at")[0].style.display="none";
    }
    if (name === "shorten_url") {
      this.setState({ errorUrlStatus: false });
    }
    if (name === "content") {
      this.setState({
        startIndex: e.target.selectionStart
      });
    }
    this.setState({ profile: data }, this.handleMessageChange);
  };
  handleDropdown = (e, {name, value}) => {
    let data = {...this.state.profile};
    let notes = data.content.substring(0, this.state.startIndex) + " " +
      value + " " +
      data.content.substring(this.state.startIndex, data.content.length)
    data['content'] = notes;
    this.setState({
      profile: data
    });
  }
  handleCannedMessage = (e, { name, value }) => {
    let data = { ...this.state.profile };
    if (value === "custom") value = "";
    data['content'] = value;
    this.setState({
      profile: data
    });
  }
  handleMessageClick = (e) => {
    this.setState({
      startIndex: e.target.selectionStart
    });
  }
  handleMessageChange = (e) => {
    this.setState({ notes: e && e.currentTarget && e.currentTarget.value });
  }
  handleKeyUp = (e) => {
    if (e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
      this.setState({
        startIndex: e.target.selectionStart
    });
    }
  }
  setProfile = result => {
    let profile = result;
    const { history } = this.props;
    if(profile.resource_id !== null){
      history.push('/social/posts');
      return false;
    }
    this.setState({
      profile: profile,
      isLoading: false
    });
  };
  setEventList = result => {
    if (!this.state.isMounted) return false;
    let eventList = this.state.eventList;
    result.data.map((value, index) =>
      eventList.push({
        text: value.title,
        value: +value.id,
        key: +value.id
      })
    );
    this.setState({
      eventList: eventList,
    });
  };
  setTokenIds = result => {
    if (!this.state.isMounted) return false;
    let tokenIds = this.state.tokenIds;
    result.data.map((value, index) =>
      tokenIds.push({
        icon: value.resource_type,
        text: value.name,
        value: +value.id,
        key: +value.id
      })
    );
    this.setState({
      tokenIds: tokenIds,
    });
  };
  setCannedMessages = result => {
    if (!this.state.isMounted) return false;
    let canned = this.state.canned;
    result.data.map((value, index) =>
      canned.push({
        text: value.title,
        value: value.content,
        key: +value.id
      })
    );
    this.setState({
      canned: canned,
    });
  };
  handleSubmit = () => {
    const { profile } = this.state;
    this.setState({
      isLoading: true,
      xhrStatus: '',
      xhrMessage: ''
    });

    let submit;
    if (profile.id > 0) {
      submit = request.put(this, `api:/social/post/${profile.id}`, profile)
    } else {
      submit = request.post(this, "api:/social/post", profile)
    }
    submit.then(resp => {
      var message;
      if (resp.errors) {
        message = Object.keys(resp.errors).map(e => {
          return <div>{resp.errors[e][0]}</div>;
        });
      }
      this.setState({
        isLoading: false,
        xhrStatus: resp.errors ? "error" : resp.success ? "success" : "error",
        xhrMessage: message ? message : resp.message
      });
    })
  };
  handleUpload = (i, file) => {
    this.setState({ loading: true });
    let profile = {...this.state.profile};
    // Initial FormData
    let images = new FormData();
    images.append("file", file);
    return request.post(this,  "api:/social/upload", images).then(resp => {
      if (resp.success === true) {
        let imgUrl = resp.url;
        profile['images'][i] = imgUrl
        this.setState({ loading: false, profile: profile, });
      }
    });
  };
  handleTrash = (i) => {
    this.setState({ loading: true });
    let profile = {...this.state.profile};
    profile['images'][i] = null
    this.setState({ loading: false, profile: profile, });
  };
  handleClick = (e) => {
    const { rebrandly } = this.context.config;
    let longUrl = document.getElementById('shortenUrlInput').value;
    let linkRequest = {
      destination: longUrl,
      domain: { fullName: rebrandly.custom_domain }
    }
    let requestHeaders = {
      "Content-Type": "application/json",
      "apikey": rebrandly.api_key,
    }
    axios({
      method: 'post',
      url: rebrandly.links_url,
      data: JSON.stringify(linkRequest),
      headers: requestHeaders,
      responseType: "json"
    })
    .then(response =>  document.getElementById('shortenUrlInput').value = response.data.shortUrl)
    .catch(error => this.setState({ errorUrlMessage: error.response.data.errors[0].message, errorUrlStatus: true }))
  }
  handleCopy = () => {
    var copyText = document.getElementById("shortenUrlInput");
    copyText.select();
    document.execCommand("copy");
  }
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      profile,
      canned,
      tokenIds,
      eventList
    } = this.state;
    const options = [
      { text: "CTA Jackpot", value: '{%%jackpot%%}', onClick: this.handleDropdown },
      { text: "CTA Jackpot Winning Ticket", value: '{%%jackpotTicket%%}', onClick: this.handleDropdown },
      { text: "Weekly Jackpot", value: '{%%prize%%}', onClick: this.handleDropdown },
      { text: "Weekly Jackpot Winning Ticket", value: '{%%prizeTicket%%}', onClick: this.handleDropdown },
      { text: "Event Title", value: '{%%event%%}', onClick: this.handleDropdown },
      { text: "Game Type", value: '{%%game%%}', onClick: this.handleDropdown },
      { text: "Non-Profit", value: '{%%nonprofit%%}', onClick: this.handleDropdown },
      { text: "E-commerce Page", value: '{%%buyUrl%%}', onClick: this.handleDropdown },
      { text: "Contact Page", value: '{%%contactUrl%%}', onClick: this.handleDropdown },
      { text: "Winners Page", value: '{%%winUrl%%', onClick: this.handleDropdown}
    ];
    return (
      <Container text>
        <Form
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
          <Form.Field>
            <label>Social Accounts</label>
            <Dropdown
              name="token_id"
              placeholder='Select the account(s) to post to'
              fluid
              selection
              multiple
              options={tokenIds}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.Field>
            <label>Event</label>
            <Dropdown
              name="event_id"
              placeholder='Choose an event'
              fluid
              selection
              options={eventList}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.Field>
          <label>Title</label>
          <Input
            placeholder="Choose a Title"
            name="title"
            value={profile.title}
            onChange={this.handleChange}
            fluid
           />
           </Form.Field>
           <Form.Field>
            <label>Message</label>
            <TextArea
              name="content"
              placeholder="Type in your message"
              value={profile.content}
              onClick={this.handleMessageClick}
              onChange={this.handleChange}
              onKeyUp={this.handleKeyUp}
              className="ui segment top attached"
            />
            <Menu attached='bottom' size='tiny'>
              <Menu.Item header>Insert</Menu.Item>
                <Dropdown
                  item
                  text='Custom variable'
                  options={options}
                />
                <Dropdown
                  item
                  text='Canned message'
                  options={canned}
                  onChange={this.handleCannedMessage}
                />
                <Menu.Item  style={{ flexGrow: 1 }}>
                <Input
                    placeholder="Paste your URL here"
                    name="shorten_url"
                    onChange={this.handleChange}
                    action
                    fluid
                    id="shortenUrlInput"
                    size="mini"
                >
                  <input />
                  <Button content="Shorten" icon="linkify" onClick={this.handleClick} size="mini"></Button>
                  <Button content="Copy" icon="copy" onClick={this.handleCopy} size="mini"></Button>
                </Input>
              </Menu.Item>
            </Menu>
          </Form.Field>
          <Form.Field>
            <label>Photo(s)</label>
            <Grid divided='vertically'>
            <Grid.Row columns={4}>
              <Grid.Column>
                <DropzoneCommon
                  onDrop={files => this.handleUpload(0, files[0])}
                  accept="image/*"
                  className="ui dropzone"
                  img={profile && profile.images[0] && profile.images[0]}
                  onTrash={() => this.handleTrash(0)}
                />
              </Grid.Column>
              <Grid.Column>
                <DropzoneCommon
                  onDrop={files => this.handleUpload(1, files[0])}
                  accept="image/*"
                  className="ui dropzone"
                  img={profile && profile.images[1] && profile.images[1]}
                  onTrash={() => this.handleTrash(1)}
                />
              </Grid.Column>
              <Grid.Column>
                <DropzoneCommon
                  onDrop={files => this.handleUpload(2, files[0])}
                  accept="image/*"
                  className="ui dropzone"
                  img={profile && profile.images[2] && profile.images[2]}
                  onTrash={() => this.handleTrash(2)}
                />
              </Grid.Column>
              <Grid.Column>
                <DropzoneCommon
                  onDrop={files => this.handleUpload(3, files[0])}
                  accept="image/*"
                  className="ui dropzone"
                  img={profile && profile.images[3] && profile.images[3]}
                  onTrash={() => this.handleTrash(3)}
                />
              </Grid.Column>
            </Grid.Row>
            </Grid>
          </Form.Field>
          <Form.Field>
              <label>Schedule</label>
              <Form.Radio
                label='Now'
                name='schedule'
                value="none"
                checked={profile.schedule === "none"}
                onChange={this.handleChange}
              />
              <Form.Radio
                label='At start of event'
                name='schedule'
                value="event"
                checked={profile.schedule === "event"}
                onChange={this.handleChange}
              />
              <Form.Radio
                label='After winning number is selected'
                name='schedule'
                value="winner"
                checked={profile.schedule === "winner"}
                onChange={this.handleChange}
              />
              <Form.Radio
                label='Custom date and time'
                name='schedule'
                value="custom"
                checked={profile.schedule === "custom"}
                onChange={this.handleChange}
              />
              <Flatpickr
                name="post_at"
                value={profile.post_at || ""}
                options={dateTimePicker}
                onChange={(_, str, b) =>
                  this.handleChange(b.element, {
                    name: "post_at",
                    value: str
                  })
                }
                onClose={(_, str, b) =>
                  this.handleChange(b.element, {
                    name: "post_at",
                    value: str
                  })
                }
                disabled={!this.state.customScheduleStatus}
                placeholder="Pick a date"
              />
          </Form.Field>
          <Form.Button
            primary
            icon="save"
            content="Save"
            floated="right"
            onClick={this.handleSubmit}
          />
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
      </Container>
    );
  }
}
SocialPostsForm.contextType = AppContext;

export default SocialPostsForm;
